/* ============================================================================
   Pitch Kits — theme.js
   Vanilla ES2017. No jQuery, no Vue, no React.
   Auto-loaded defer. Safe on all pages.
   ============================================================================ */
(function(){
  'use strict';

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const $  = (sel, root = document) => root.querySelector(sel);

  /* ----------------------------------------------------------------------------
     1. Theme toggle (dark <-> light) with localStorage persistence
  ---------------------------------------------------------------------------- */
  function initThemeToggle() {
    const btn = $('[data-theme-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const cur = document.documentElement.getAttribute('data-theme') || 'dark';
      const next = cur === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      try { localStorage.setItem('pk-theme', next); } catch (_) {}
      btn.setAttribute('aria-label', next === 'light' ? 'Switch to dark' : 'Switch to light');
    });
  }

  /* ----------------------------------------------------------------------------
     2. Desktop nav with mega menu (hover + click fallback + close buffer)
  ---------------------------------------------------------------------------- */
  function initNav() {
    const items = $$('.site-nav__item.has-mega');
    if (!items.length) return;

    let closeTimer = null;

    function open(item) {
      clearTimeout(closeTimer);
      items.forEach(i => {
        i.classList.remove('is-open');
        const trig = $('.site-nav__link', i);
        if (trig) trig.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-open');
      const trig = $('.site-nav__link', item);
      if (trig) trig.setAttribute('aria-expanded', 'true');
    }
    function close(item) {
      item.classList.remove('is-open');
      const trig = $('.site-nav__link', item);
      if (trig) trig.setAttribute('aria-expanded', 'false');
    }
    function scheduleClose(item) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => close(item), 150);
    }

    items.forEach(item => {
      const link = $('.site-nav__link', item);
      const panel = $('.mega-menu', item);

      // desktop hover open
      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) open(item);
      });
      item.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches) scheduleClose(item);
      });

      // cancel close when re-entering the panel
      if (panel) {
        panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        panel.addEventListener('mouseleave', () => scheduleClose(item));
      }

      // click fallback (touch / mobile / keyboard)
      if (link) {
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          const isTouch = !window.matchMedia('(hover: hover)').matches;
          // touch: toggle dropdown via click, not navigate
          if (isTouch && panel) { e.preventDefault(); item.classList.contains('is-open') ? close(item) : open(item); return; }
          // desktop with no href: just toggle
          if ((!href || href === '#') && panel) { e.preventDefault(); item.classList.contains('is-open') ? close(item) : open(item); }
        });
      }
    });

    // close on outside click / esc
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.site-nav__item.has-mega')) items.forEach(close);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') items.forEach(close);
    });
  }

  /* ----------------------------------------------------------------------------
     3. Mobile drawer toggle
  ---------------------------------------------------------------------------- */
  function initMobileDrawer() {
    const drawer = $('[data-mobile-drawer]');
    if (!drawer) return;
    const openBtns  = $$('[data-mobile-open]');
    const closeBtns = $$('[data-mobile-close]');

    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('drawer-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('drawer-open');
    }

    openBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    closeBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); close(); }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    // close drawer when navigating to an internal link
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (a && !a.matches('[data-mobile-close]') && a.getAttribute('href') !== '#') close();
    });
  }

  /* ----------------------------------------------------------------------------
     4. Cart drawer open / close / fetch / add / qty / remove
  ---------------------------------------------------------------------------- */
  const Cart = {
    open()  { document.body.classList.add('is-cart-open'); document.body.style.overflow = 'hidden'; },
    close() { document.body.classList.remove('is-cart-open'); document.body.style.overflow = ''; },
    async refresh() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('cart fetch failed');
        const cart = await res.json();
        this.render(cart);
        this.updateCount(cart.item_count);
        return cart;
      } catch (e) {
        console.error('[Cart.refresh]', e);
      }
    },
    render(cart) {
      const body  = $('[data-cart-body]');
      const total = $('[data-cart-total]');
      if (!body) return;

      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-drawer__empty">' + (window.PKLocale?.empty || 'Your cart is empty') + '</p>';
        if (total) total.textContent = window.PKMoney?.format(0) || '$0.00';
        return;
      }

      body.innerHTML = cart.items.map(it => `
        <div class="cart-drawer__line">
          <a class="cart-drawer__line-img" href="${it.url}">
            <img src="${it.image || ''}" alt="${(it.title || '').replace(/"/g,'&quot;')}" loading="lazy">
          </a>
          <div class="cart-drawer__line-info">
            <a class="cart-drawer__line-title" href="${it.url}">${it.title}</a>
            <div class="cart-drawer__line-meta">${it.variant_title || ''}</div>
            <div class="cart-drawer__line-price">${window.PKMoney?.format(it.final_line_price) || ''}</div>
            <div class="cart-drawer__line-qty">
              <button class="cart-drawer__qty-btn" data-cart-qty="dec" data-line="${it.key}">−</button>
              <span>${it.quantity}</span>
              <button class="cart-drawer__qty-btn" data-cart-qty="inc" data-line="${it.key}">+</button>
              <button class="cart-drawer__remove" data-cart-remove data-line="${it.key}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');

      if (total) total.textContent = window.PKMoney?.format(cart.total_price) || '';
    },
    updateCount(count) {
      $$('.cart-button__count').forEach(b => {
        b.textContent = count;
        b.classList.toggle('has-count', count > 0);
      });
    },
    async add(variantId, qty = 1) {
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        await this.refresh(); this.open();
      } catch (e) { console.error('[Cart.add]', e); }
    },
    async change(lineKey, qty) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: qty })
        });
        await this.refresh();
      } catch (e) { console.error('[Cart.change]', e); }
    },
    async remove(lineKey) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });
        await this.refresh();
      } catch (e) { console.error('[Cart.remove]', e); }
    }
  };
  window.PKCart = Cart;

  function initCart() {
    const openBtns  = $$('[data-cart-open]');
    const closeBtns = $$('[data-cart-close]');
    openBtns.forEach(b => b.addEventListener('click', () => Cart.open()));
    closeBtns.forEach(b => b.addEventListener('click', () => Cart.close()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') Cart.close(); });

    // delegate qty/remove inside drawer
    document.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty]');
      const rmBtn  = e.target.closest('[data-cart-remove]');
      if (qtyBtn) {
        const line = qtyBtn.getAttribute('data-line');
        const dir  = qtyBtn.getAttribute('data-cart-qty');
        // fetch current qty
        const cart = await Cart.refresh();
        const item = cart?.items.find(i => i.key === line);
        if (!item) return;
        const next = dir === 'inc' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        next === 0 ? Cart.remove(line) : Cart.change(line, next);
      }
      if (rmBtn) {
        Cart.remove(rmBtn.getAttribute('data-line'));
      }
    });

    // add-to-cart forms on product page
    $$('form[action="/cart/add"]').forEach(f => {
      f.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(f);
        const variantId = fd.get('id');
        const qty = parseInt(fd.get('quantity') || '1', 10);
        await Cart.add(variantId, qty);
      });
    });

    // initial count
    Cart.refresh();
  }

  /* ----------------------------------------------------------------------------
     5. Variant picker (size + color) on product page
  ---------------------------------------------------------------------------- */
  function initVariantPicker() {
    const forms = $$('form[data-product-form]');
    forms.forEach(form => {
      const variants = JSON.parse(form.getAttribute('data-variants') || '[]');
      const optionGroups = $$('[data-option]', form);
      const variantInput = form.querySelector('[data-variant-input]');
      const priceEl  = form.querySelector('[data-price]');
      const cpriceEl = form.querySelector('[data-compare-price]');
      const stockEl  = form.querySelector('[data-stock]');

      function findVariant(opts) {
        return variants.find(v =>
          v.options.length === opts.length &&
          v.options.every((o, i) => String(o) === String(opts[i]))
        );
      }
      function update(opts) {
        const variant = findVariant(opts);
        if (variant) {
          variantInput.value = variant.id;
          if (priceEl)  priceEl.textContent = window.PKMoney?.format(variant.price) || '';
          if (cpriceEl) cpriceEl.style.display = variant.compare_at_price > variant.price ? '' : 'none';
          if (cpriceEl) cpriceEl.textContent = variant.compare_at_price ? window.PKMoney?.format(variant.compare_at_price) : '';
          if (stockEl) {
            stockEl.classList.toggle('is-out', !variant.available);
            stockEl.textContent = variant.available
              ? (window.PKLocale?.inStock || 'In stock')
              : (window.PKLocale?.soldOut || 'Sold out');
          }
        }
      }

      // initialize
      const initialOpts = optionGroups.map(g => g.querySelector('[data-option-value].is-active')?.getAttribute('data-option-value')).filter(Boolean);
      if (initialOpts.length === optionGroups.length) update(initialOpts);

      optionGroups.forEach((group) => {
        $$('[data-option-value]', group).forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            $$('[data-option-value]', group).forEach(x => x.classList.remove('is-active'));
            el.classList.add('is-active');
            const newOpts = optionGroups.map(g => g.querySelector('[data-option-value].is-active')?.getAttribute('data-option-value'));
            update(newOpts);
          });
        });
      });

      // qty +/-
      const dec = form.querySelector('[data-qty="dec"]');
      const inc = form.querySelector('[data-qty="inc"]');
      const qtyInput = form.querySelector('[data-qty-input]');
      if (dec && inc && qtyInput) {
        dec.addEventListener('click', () => qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10) || 1) - 1));
        inc.addEventListener('click', () => qtyInput.value = (parseInt(qtyInput.value,10) || 1) + 1);
      }
    });
  }

  /* ----------------------------------------------------------------------------
     6. Gallery — click thumbnail swaps main image (product page)
  ---------------------------------------------------------------------------- */
  function initGallery() {
    $$('.gallery').forEach(gallery => {
      const mainWrap = $('.gallery__main', gallery);
      const main = mainWrap ? $('.gallery__main img', gallery) : null;
      if (!mainWrap || !main) return;

      $$('.gallery__thumb', gallery).forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const src = thumb.getAttribute('data-src');
          const srcset = thumb.getAttribute('data-srcset');
          if (!src) return;
          // remove active
          $$('.gallery__thumb', gallery).forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          // swap with fade
          mainWrap.classList.add('is-loading');
          const tmp = new Image();
          tmp.onload = () => {
            main.src = src;
            if (srcset) main.srcset = srcset;
            mainWrap.classList.remove('is-loading');
          };
          tmp.onerror = () => {
            mainWrap.classList.remove('is-loading');
          };
          tmp.src = src;
        });
      });
    });
  }

  /* ----------------------------------------------------------------------------
     7. Accordion
  ---------------------------------------------------------------------------- */
  function initAccordion() {
    $$('.accordion-item').forEach(item => {
      const trigger = $('.accordion-trigger', item);
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        item.classList.toggle('is-open');
      });
    });
  }

  /* ----------------------------------------------------------------------------
     8. Tabs (description / specs / reviews)
  ---------------------------------------------------------------------------- */
  function initTabs() {
    $$('[data-tabs]').forEach(group => {
      const triggers = $$('[data-tab]', group);
      const panels   = $$('[data-panel]', group);
      triggers.forEach(trig => {
        trig.addEventListener('click', () => {
          const target = trig.getAttribute('data-tab');
          triggers.forEach(t => t.classList.toggle('is-active', t === trig));
          panels.forEach(p => p.classList.toggle('is-hidden', p.getAttribute('data-panel') !== target));
        });
      });
    });
  }

  /* ----------------------------------------------------------------------------
     9. Reveal on scroll
  ---------------------------------------------------------------------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    $$('[data-reveal]').forEach(el => io.observe(el));
  }

  /* ----------------------------------------------------------------------------
     10. Money formatter (uses Shopify currency)
  ---------------------------------------------------------------------------- */
  function initMoney() {
    const fmt = (cents) => {
      if (typeof cents !== 'number') return '';
      const money = window.Shopify?.money_format || window.theme?.money_format || '${{amount}}';
      try {
        const formatted = money.replace(/\{\{\s*amount\s*\}\}/g, (cents/100).toFixed(2));
        return formatted;
      } catch (_) { return '$' + (cents/100).toFixed(2); }
    };
    window.PKMoney = { format: fmt };
  }

  /* ----------------------------------------------------------------------------
     11. Sticky header — toggle .is-scrolled on scroll past threshold
  ---------------------------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('[data-site-header]');
    if (!header || !header.classList.contains('site-header--sticky')) return;
    const THRESHOLD = 8;
    let raf = 0;
    const onScroll = () => {
      raf = 0;
      const y = window.scrollY || document.documentElement.scrollTop;
      header.classList.toggle('is-scrolled', y > THRESHOLD);
    };
    window.addEventListener('scroll', () => {
      if (!raf) raf = requestAnimationFrame(onScroll);
    }, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------------------------
     12. Mobile browser-UI safe-area detection
     Sets --sai-top / --sai-bottom CSS variables on :root so the fixed
     announcement-bar and bottom-tabbar can float just below the iOS Safari
     URL bar / above the iOS Safari bottom toolbar or Android Chrome system
     navigation bar. Skipped on desktop (>=1024px).

     iOS Safari: visualViewport.offsetTop == URL bar height when shown.
     Android Chrome: visualViewport.offsetTop is usually 0 (URL bar isn't
     part of the visual viewport on Android), so we fall back to a fixed
     value keyed off scrollY.
  ---------------------------------------------------------------------------- */
  function initSafeArea() {
    if (window.matchMedia('(min-width: 1024px)').matches) return;

    const root = document.documentElement;
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Mac/.test(ua) && 'ontouchend' in document);

    function update() {
      let top = 0, bottom = 0;

      if (window.visualViewport) {
        const vv = window.visualViewport;
        // iOS Safari uses offsetTop for the URL bar height
        const offsetTop = Math.max(0, vv.offsetTop || 0);
        const layoutH = document.documentElement.clientHeight;
        // bottom = layout viewport - (visual viewport + offsetTop)
        // This is the height of the bottom toolbar (iOS) or system nav (Android)
        const bottomInset = Math.max(0, layoutH - (vv.height + offsetTop));
        top = offsetTop;
        bottom = bottomInset;
      }

      if (isAndroid) {
        // Android Chrome: visualViewport.offsetTop is 0 even when URL bar is
        // showing. URL bar is ~56px when at top of page, hidden once scrolled.
        // Bottom: system navigation can be either gesture bar (~24px) or
        // 3-button bar (~48px). Use the wider estimate by default — body has
        // enough padding-bottom to absorb the extra even when it's smaller.
        const scrolled = (window.scrollY || 0) > 50;
        top = scrolled ? 0 : 56;
        bottom = 48;
      }

      // Clamp to sensible values to avoid negative or huge insets
      top = Math.max(0, Math.min(top, 120));
      bottom = Math.max(0, Math.min(bottom, 120));

      // Always reserve at least the height of our own bottom-tabbar (~64px)
      // so the page never gets eaten even when --sai-bottom reports 0
      // (e.g. when the user is on desktop with touch emulation enabled).
      const minBottom = window.matchMedia('(max-width: 767.98px)').matches ? 56 : 0;
      bottom = Math.max(bottom, minBottom);

      root.style.setProperty('--sai-top', top + 'px');
      root.style.setProperty('--sai-bottom', bottom + 'px');
    }

    update();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', update);
      window.visualViewport.addEventListener('scroll', update);
    }
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', () => setTimeout(update, 200));
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ----------------------------------------------------------------------------
     13. Zoom lock — last-resort pinch guard
     Normal mobile browsers are handled by the viewport meta tag
     (user-scalable=no, maximum-scale=1) plus CSS touch-action. Some in-app
     browsers / WebViews (WeChat, older Android WebViews) ignore both, so we
     also swallow two-finger pan gestures here. One-finger scrolling and all
     taps are untouched.
  ---------------------------------------------------------------------------- */
  function initZoomLock() {
    document.addEventListener('touchmove', (e) => {
      if (e.touches && e.touches.length > 1) e.preventDefault();
    }, { passive: false });

    // iOS Safari / WebView-only legacy event, harmless elsewhere.
    document.addEventListener('gesturestart', (e) => e.preventDefault());
  }

  /* ----------------------------------------------------------------------------
     Bootstrap — DOM ready
  ---------------------------------------------------------------------------- */
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(() => {
    initMoney();
    initThemeToggle();
    initNav();
    initMobileDrawer();
    initCart();
    initVariantPicker();
    initGallery();
    initAccordion();
    initTabs();
    initReveal();
    initStickyHeader();
    initSafeArea();
    initZoomLock();
  });
})();
